export default __webpack_public_path__ + "static/media/logo_v2.8ddb6d7a.png";